import React from 'react';
import BibleVerse from '../../../components/BibleVerse';

const PurchaseControls = ({ bible }) => {
  const showStockWarning =
    bible?.inStock && bible?.stockCount > 0 && bible?.stockCount <= 5;

  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:block lg:col-span-4 space-y-4">
        <BibleVerse />

        {showStockWarning && (
          <div className="p-3 bg-warning/10 border border-warning/20 rounded-lg">
            <p className="text-sm text-warning-foreground text-center">
              ⚠️ Solo quedan {bible.stockCount} unidades disponibles
            </p>
          </div>
        )}
      </div>

      {/* Mobile */}
      <div className="lg:hidden sticky bottom-16 bg-background border-t border-border p-4 space-y-4">
        <BibleVerse />

        {showStockWarning && (
          <div className="p-3 bg-warning/10 border border-warning/20 rounded-lg">
            <p className="text-sm text-warning-foreground text-center">
              ⚠️ Solo quedan {bible.stockCount} unidades disponibles
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default PurchaseControls;

